import { Card, CardContent, CardProps } from '@material-ui/core';
import { CardTitleTypography } from 'framework/components/CardTitleTypography';
import { isLast } from 'framework/utils/array/isLast';
import { IStockMovement } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { StockMovementLineListItem } from './StockMovementLineListItem';

interface IProps extends CardProps {
	item: IStockMovement;
}

export const StockMovementDetailContentsCard = ({ item, ...rest }: IProps) => {
	const strings = useLocalization();

	return (
		<Card {...rest}>
			<CardContent>
				<CardTitleTypography
					title={strings.contents}
					style={{ marginBottom: 8 }}
				/>
				{item.lines.map(t => (
					<StockMovementLineListItem
						line={t}
						key={t.id}
						withoutBorder={isLast(t, item.lines)}
					/>
				))}
				{item.lines.length === 0 && <em>{strings.noLinesDefinedYet}</em>}
			</CardContent>
		</Card>
	);
};
